<template>
	<vxe-modal :loading="loading" v-model="modal" width="500" height="auto" @show="show" title="回单" destroy-on-close
		:showFooter="true">
		<template #default>
			<el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="供应商编码">
					<el-input readonly v-model="receiptInfo.code"></el-input>
				</el-form-item>
				<el-form-item label="供应商名称">
					<el-input readonly v-model="receiptInfo.name"></el-input>
				</el-form-item>
				<el-form-item label="微信群ID">
					<el-input readonly v-model="receiptInfo.roomid"></el-input>
				</el-form-item>
				<el-form-item label="下载编码">
					<el-input readonly v-model="receiptInfo.receiptdownloadNo">
						<el-button type="primary" slot="append" icon="el-icon-refresh-left"
							@click="reflashDownloadNo"></el-button>
					</el-input>
				</el-form-item>
			</el-form>
		</template>
		<template #footer>
			<vxe-button status="" content="下载" @click="getReceipt('download')"></vxe-button>
			<vxe-button status="primary" content="发送" @click="getReceipt('send')"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			row: {
				default: () => {
					return null
				}
			},
			receiptType: {
				default: () => {
					return 'CD'
				}
			},
			receiptInfo: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				form: {
					mkcode: '',
					checkstaffid: null,
				},
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				if(!this.receiptInfo.receiptdownloadNo){
					this.reflashDownloadNo()
				}
			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {
				this.init()
			},
			showPhone() {
				this.activeName = 0
				this.handleClickPhone(this.activeName)
			},
			modalShow() {
				this.modal = true
			},
			staffsubmit(e) {
				this.form.checkstaffid = e.data
			},
			submit() {
				this.$api.reconciliation_bankflow.setMkCode(this.row.id, this.form).then(() => {
					this.$message.success('操作成功')
					this.$emit('success')
					this.cancel()
				})

				//this.cancel()
			},
			reflashDownloadNo() {
				this.$api.paymentapplication.reflashDownloadNo({
					type: this.receiptType,
					purchasecode: this.receiptInfo.purchasecode
				}).then((res) => {
					this.receiptInfo.receiptdownloadNo = res
				})
			},
			getReceipt(action) {
				let handle = this.$loading()
				this.$api.paymentapplication.sendReceipt({
					supplierwlnid: this.row.purchasesupplierid,
					id: this.row.paymentapplicationid,
					type: this.receiptType,
					action: action
				}).then((res) => {
					this.$loadingclose(handle)
					if (action == 'download') {
						window.open(res, '_blank');
					} else {

						this.cancel()
						this.$message.success('操作成功')
					}
				}, () => {
					this.$loadingclose(handle)
				})
			}
		},
		components: {

		}
	}
</script>